'use strict';

import Timer from 'easytimer.js';

export default class Bonuses {
	constructor(params) {
		if (!document.querySelector('.bonuses')) return false;
		this._matchHTML();
		this._bindCardFormHandler();
		this._userProfileBtnHandler();
		this._cardViewHandler();
		this._addCardByNum();
		this._userProfileForm();
		this._bonusCardChoose();
		this._reloadOnClose();
		// this._refresh();
		// this._removeCard();
		if (!params || (params && !params.inCart)) {
			this._moveOnMobile();
		}
	}

	_matchHTML() {
		this.ajaxContainer = document.querySelector('[data-bonuses-ajax-container]');
		// this.cardViewContainer = document.querySelector('[data-card-view]');
		// this.bonusesContainer = this.cardViewContainer.querySelector('[data-bonuses]');
		// this.giftBonusesContainer = this.cardViewContainer.querySelector('[data-gift-bonuses]');
		// this.giftBonusesCountContainer = this.cardViewContainer.querySelector('[data-gift-bonuses-count]');
		// this.refreshBtn = this.cardViewContainer.querySelector('[data-refresh]');
		// this.cardNumContainer = this.cardViewContainer.querySelector('[data-card-num]');
		// this.removeBtn = this.cardViewContainer.querySelector('[data-remove-card]');
	}


	_initSMSTimer(min, sec, phoneNum, callback) {
		let $timerContainer = $('body').find('[data-timer]'),
			$min = $timerContainer.find('[data-timer-min]'),
			$sec = $timerContainer.find('[data-timer-sec]'),
			that = this;

		min = parseInt(min);
		sec = parseInt(sec);

		that.timer = new Timer();

		$timerContainer.show();

		that.timer.start({countdown: true, startValues: {minutes: min, seconds: sec}});
		$min.html(that.timer.getTimeValues().toString(['minutes']));
		$sec.html(that.timer.getTimeValues().toString(['seconds']));

		that.timer.addEventListener('secondsUpdated', function (e) {
			$min.html(that.timer.getTimeValues().toString(['minutes']));
			$sec.html(that.timer.getTimeValues().toString(['seconds']));
		});

		that.timer.addEventListener('targetAchieved', function (e) {
			$('[data-send-retry]').show();
			$timerContainer.hide();

			if (phoneNum) {
				that._sendRetryHandler(phoneNum);
			}
		});
	}


	_bindCardFormHandler()
	{
		this.cardBind = document.querySelectorAll('[data-bind-card]');
		if (this.cardBind.length === 0) return false;
		for (let j = 0; j < this.cardBind.length; j++)
		{
			this.cardBindForms = this.cardBind[j].querySelectorAll('[data-bind-card-form]');
			// this.bindPhoneField = this.cardBindForm.querySelector('[data-bind-phone-field]');
			// this.cardCheckContainer = document.querySelector('[data-card-check]');

			let that = this;
			for (let i = 0; i < this.cardBindForms.length; i++)
			{
				$(this.cardBindForms[i]).validate({
					submitHandler: function (form)
					{
						let formData = $(form).serialize();
						$.ajax({
							url: form.action,
							type: form.method,
							data: formData,
							dataType: 'json',
							beforeSend: function ()
							{
								that.ajaxContainer.classList.add('is-loading');
							},
							success: function (res)
							{
								that.ajaxContainer.classList.remove('is-loading');
								let min = 0,
									sec = 0,
									phone = res.phone;

								min = parseInt(res.timer.min);
								sec = parseInt(res.timer.sec);

								if (res.modalUrl)
								{
									$.ajax({
										url: res.modalUrl,
										data: {'phone': phone},
										beforeSend: function ()
										{
											document.body.classList.add('is-loading');
										},
										success: function (res)
										{
											document.body.classList.remove('is-loading');
											let modal,
												$min,
												$sec,
												phoneNum = that.cardBindForms[i].querySelector('[name=phone-num]').value;


											that._initModals(res, function ()
											{
												if (that.timer)
												{
													that.timer.stop();
												}
											})

											that._initSMSTimer(min, sec, phoneNum);
											that._confirmCodeFormHandler();
										}
									});

								}
							}
						});
					}
				});
			}
		}
	}

	_unbindCardFormHandler() {
		this.cardUnBindForm = document.querySelector('[data-unbind-card-form]');
		let that = this;

		if (!this.cardUnBindForm) return false;

		this.cardUnBindForm.addEventListener('submit', event => {
			event.preventDefault();
			let formData = $(that.cardUnBindForm).serialize();

			$.ajax({
				url: that.cardUnBindForm.action,
				type: that.cardUnBindForm.method,
				data: formData,
				dataType: 'json',
				success: function (res) {
					if (res.modalUrl) {
						$.ajax({
							url: res.modalUrl,
							data: res.data,
							beforeSend: function () {
								document.body.classList.add('is-loading');
							},
							success: function (res) {
								document.body.classList.remove('is-loading');
								that._initModals(res);
							}
						});
					}
				}
			});
		});
	}

	_userProfileBtnHandler() {
		let profileBtn = document.querySelector('[data-user-profile]:not(.is-inited)'),
			that = this;

		if (!profileBtn) return false;

		profileBtn.addEventListener('click', event => {
			event.preventDefault();

			let url = profileBtn.href;
			let params = {
				'step': 'getUserProfile'
			};

			$.ajax({
				url: url,
				dataType: 'json',
				data: params,
				method: "POST",
				beforeSend: function () {
					that.ajaxContainer.classList.add('is-loading');
				},
				success: function (res) {
					that.ajaxContainer.classList.remove('is-loading');
					if (res.modalUrl) {
						loadModalByUrl(res.modalUrl)
					}
				}
			});
		})

		profileBtn.classList.add('is-inited');
	}

	_sendRetryHandler(phoneNum) {
		let retryBtn = document.querySelector('[data-send-retry]'),
			that = this;

		if (!retryBtn) return false;

		retryBtn.addEventListener('click', event => {
			event.preventDefault();
			let url = retryBtn.dataset.sendRetry;
			let params = {
				'phone-num': phoneNum,
				'step': 'retryPhoneConfirmation'
			};

			$(retryBtn).hide();

			$.ajax({
				url: url,
				dataType: 'json',
				data: params,
				method: "POST",
				success: function (res) {
					let min = res.timer.min,
						sec = res.timer.sec;

					that._initSMSTimer(min, sec)
				}
			});
		})
	}

	_confirmCodeFormHandler() {
		var forms = document.querySelectorAll('[data-confirm-form]');
		this.confirmForm = forms[forms.length-1];
		let that = this;

		if (!this.confirmForm) return false;

		let codeField = this.confirmForm.querySelector('[data-confirm-code]'),
			submitBtn = this.confirmForm.querySelector('[type=submit]'),
			confirmError = this.confirmForm.querySelector('[data-confirm-error]'),
			validator = $(this.confirmForm).validate();

		codeField.addEventListener('input', event => {
			codeField.classList.remove('error');
			confirmError.style.display = "none";
			if (codeField.value.length > 0) {
				submitBtn.disabled = false;
			} else {
				submitBtn.disabled = true;
			}
		});

		this.confirmForm.addEventListener('submit', event => {
			event.preventDefault();

			let formData = $(this.confirmForm).serialize();

			$.ajax({
				url: that.confirmForm.action,
				type: that.confirmForm.method,
				data: formData,
				dataType: 'json',
				method: 'POST',
				beforeSend: function () {
					document.body.classList.add('is-loading');
				},
				success: function (res) {
					document.body.classList.remove('is-loading');
					if (res.success) {
						if (res.modalUrl) {
							closeModals();
							$.ajax({
								url: res.modalUrl,
								data: res.data,
								beforeSend: function () {
									document.body.classList.add('is-loading');
								},
								success: function (res) {
									document.body.classList.remove('is-loading');
									that._initModals(res);
									that._unbindCardFormHandler();
								}
							});
						}
					} else {
						codeField.classList.add('error');
						confirmError.innerHTML = res.error;
						confirmError.style.display = "block";
					}
				}
			});
		})
	}

	_addCardByNum() {
		let that = this;
		$(document).on($.modal.OPEN, function (event) {
			let $modal = $(event.target);
			let $form = $modal.find('[data-add-card-num]');
			let $cardNum = $form.find('[data-card-num-field]');

			if ($form.length < 1) return false;

			$form.validate({
				submitHandler: function (form) {
					let formData = $(form).serialize();
					$.ajax({
						url: form.action,
						type: form.method,
						data: formData,
						dataType: 'json',
						beforeSend: function () {
							document.body.classList.add('is-loading');
						},
						success: function (res) {
							document.body.classList.remove('is-loading');

							if (res.modalUrl) {
								closeModals();
								$.ajax({
									url: res.modalUrl,
									data: res.data,
									beforeSend: function () {
										document.body.classList.add('is-loading');
									},
									success: function (res) {
										document.body.classList.remove('is-loading');
										that._initModals(res);
									}
								});

							}
						}
					});
				}
			});

			// $cardNum.rules('add', {
			// 	minlength: 12,
			// 	maxlength: 13,
			// 	messages: { // optional custom messages
			// 		maxlength: jQuery.validator.format("Пожалуйста, введите не более {0} символов"),
			// 		minlength: jQuery.validator.format("Пожалуйста, введите не менее {0} символов")
			// 	}
			// });
		});
	}

	_onUserConsentChange() {
		if ($(this).prop("checked")) {
			$.ajax({
				type: "POST",
				url: "/local/ajax/userConsent.php",
				dataType: "json",
				data: {
					ID: "2",
					URL: window.location.href + "?modal=bonusCardForm",
					sessid: BX.bitrix_sessid()
				},
				success: (res) => {
					if (res.success) {
						$(this).off("change");
					}
				}
			});
		}
	}

	_userProfileForm() {
		let that = this;
		$(document).on($.modal.OPEN, function (event) {
			let $modal = $(event.target),
				$form = $modal.find('[data-user-profile-form]'),
				$consent = $modal.find("[data-consent]");

			if ($form.length < 1) return false;

			$consent.on("change", that._onUserConsentChange);

			$form.validate({
				submitHandler: function (form) {
					let formData = $(form).serialize();
					$.ajax({
						url: form.action,
						type: form.method,
						data: formData,
						dataType: 'json',
						beforeSend: function () {
							document.body.classList.add('is-loading');
						},
						success: function (res) {
							document.body.classList.remove('is-loading');

							if (res.containerView) {
								let content = $(res.containerView).find('[data-bonuses-ajax-container]').html();
								$(that.ajaxContainer).html(content);
								that._cardViewHandler();
								that._userProfileBtnHandler();
							}

							if (res.modalUrl) {
								$.ajax({
									url: res.modalUrl,
									beforeSend: function () {
										document.body.classList.add('is-loading');
									},
									success: function (res) {
										document.body.classList.remove('is-loading');
										that._initModals(res);
									}
								});

							}
						}
					});
				}
			});
		});
	}

	_bonusCardChoose() {
		let that = this;
		$(document).on($.modal.OPEN, function (event, modal) {
			let $modal = $(event.target),
				$form = $modal.find('[data-bonus-card-choose]');

			if ($form.length < 1) return false;

			let radios = $form[0].querySelectorAll('input[type="radio"]'),
				submit = $form[0].querySelector('[type="submit"]');

			$form.validate({
				submitHandler: function (form) {
					let formData = $(form).serialize();
					$.ajax({
						url: form.action,
						type: form.method,
						data: formData,
						dataType: 'json',
						beforeSend: function () {
							document.body.classList.add('is-loading');
						},
						success: function (res) {
							document.body.classList.remove('is-loading');

							if (res.modalUrl) {
								$.ajax({
									url: res.modalUrl,
									data: res.data,
									beforeSend: function () {
										document.body.classList.add('is-loading');
									},
									success: function (res) {
										document.body.classList.remove('is-loading');
										that._initModals(res);
									}
								});

							}
						}
					});
				}
			});


			radios.forEach(radio => {
				if (radio.checked) {
					$form.find('tr').removeClass('is-active');
					$(radio).closest('tr').addClass('is-active');
					submit.disabled = false;
				}
				radio.addEventListener('change', e => {
					if (radio.checked) {
						$form.find('tr').removeClass('is-active');
						$(radio).closest('tr').addClass('is-active');
						submit.disabled = false;
					}
				})
			})

		});
	}

	_reloadOnClose() {
		$(document).on($.modal.CLOSE, function (event, modal) {
			let $modal = modal.$elm;
			let needReload = (typeof $modal.data("reload-close") !== 'undefined') ? true : false;
			if (needReload) window.location.reload(true);
		});
	}

	_cardViewHandler() {
		this.cardViewContainer = document.querySelector('[data-card-view]');
		if (!this.cardViewContainer) return false;

		this.refreshBtn = this.cardViewContainer.querySelector('[data-refresh]');
		this.removeBtns = [...this.cardViewContainer.querySelectorAll('[data-remove-card]')];
		this.resetCardBtn = this.cardViewContainer.querySelector('[data-reset-card]');

		this._removeCard();
		this._userProfileBtnHandler();
		this._refresh();
		this._resetCard();
	}

	_resetCard() {
		if (!this.resetCardBtn) return false;

		let that = this;

		this.resetCardBtn.addEventListener('click', event => {
			event.preventDefault();

			$.ajax({
				url: this.resetCardBtn.href,
				beforeSend: function () {
					that.ajaxContainer.classList.add('is-loading');
				},
				success: function (res) {
					that.ajaxContainer.classList.remove('is-loading');
					let modal = $(res).appendTo('body').modal();

					modal.on($.modal.CLOSE, function (event, m) {
						m.elm.remove();
					});

					that._resetCardModalBtn();

				}
			});
		})
	}

	_refresh() {
		if (!this.refreshBtn) return false;

		let that = this;
		let isLoading = false;

		this.refreshBtn.addEventListener('click', event => {
			event.preventDefault();

			if (!isLoading) {

				isLoading = true;

				$.ajax({
					url: that.refreshBtn.dataset.refresh,
					data: {'step': 'refreshBalance'},
					method: 'POST',
					dataType: 'json',
					beforeSend: function () {
						that.refreshBtn.classList.add('spin-animation');
					},
					success: function (res) {
						if (res.success) {
							if (res.containerView) {
								setTimeout(function () {
									that.refreshBtn.classList.remove('spin-animation');
								}, 500);

								let content = $(res.containerView).find('[data-bonuses-ajax-container]').html();
								$(that.ajaxContainer).html(content);

								that._cardViewHandler();
							}
							if (res.popupUrl) {
								window.loadModalByUrl(res.popupUrl);
							}
						}

						isLoading = false;
					}
				});
			}
		});
	}

	_removeCard() {
		if (!this.removeBtns.length) return false;

		let that = this;

		this.removeBtns.forEach(btn => {
			btn.addEventListener('click', event => {
				event.preventDefault();

				loadModalByUrl(btn.href)
				$.ajax({
					url: btn.href,
					success: function (res) {
						that._removeCardModalBtn();
					}
				});
			})
		})

	}

	_removeCardModalBtn() {
		var forms = document.querySelectorAll('[data-modal-remove-card]');
		this.removeForm = forms[forms.length-1];
		let that = this;

		if (!this.removeForm) return false;

		this.removeForm.addEventListener('submit', event => {
			event.preventDefault();

			let formData = $(that.removeForm).serialize();

			$.ajax({
				url: that.removeForm.action,
				type: that.removeForm.method,
				data: formData,
				dataType: 'json',
				beforeSend: function () {
					document.body.classList.add('is-loading');
				},
				success: function (res) {
					document.body.classList.remove('is-loading');

					if (res.containerView) {
						let content = $(res.containerView).find('[data-bonuses-ajax-container]').html();
						$(that.ajaxContainer).html(content);

						that._bindCardFormHandler();
					}

					if (res.modalUrl) {
						loadModalByUrl(res.modalUrl)
						$.ajax({
							url: res.modalUrl,
							beforeSend: function () {
								document.body.classList.add('is-loading');
							},
							success: function (res) {
								document.body.classList.remove('is-loading');
								that._initModals(res);
							}
						});

					}
				}
			});
		});
	}

	_closeConfirm() {
		let that = this;
		$('[data-confirm-close-modal]').modal({
			closeExisting: false
		})

		$('[data-confirm-close-modal]').on($.modal.CLOSE, function (event, m) {
			$(document).off('keydown.modal').on('keydown.modal', function (event) {
				if (event.which === 27) that._closeConfirm();
			});
		})
	}

	_initModals(res, closeCallback) {
		let modal,
			that = this;

		if ($(res).data('confirm-close') !== undefined) {
			modal = $(res).appendTo('body').modal({
				clickClose: false,
				escapeClose: false,
			});


			modal.find('.close-modal').on('click', function (e) {
				e.preventDefault();
				that._closeConfirm();
			});

			$('.jquery-modal.blocker').on('click', function (e) {
				if (e.target === this) {
					that._closeConfirm();
				}
			});

			$(document).off('keydown.modal').on('keydown.modal', function (event) {
				if (event.which === 27) {
					that._closeConfirm();
				}
			});

		} else {
			modal = $(res).appendTo('body').modal();
		}

		modal.on($.modal.CLOSE, function (event, m) {
			if (that.timer) {
				that.timer.stop();
			}

			if (closeCallback !== undefined) closeCallback();

			$(document).off('keydown.modal');
		});

		this._openModalWithParams(modal);
	}

	_openModalWithParams(modal) {
		let btns = [...modal[0].querySelectorAll('[data-open-modal]')],
			that = this;
		if (btns.length) {
			btns.forEach(btn => {
				btn.addEventListener('click', e => {
					e.preventDefault();
					let url = btn.dataset.openModal;
					$.ajax({
						url: url,
						beforeSend: function () {
							document.body.classList.add('is-loading');
						},
						success: function (res) {
							document.body.classList.remove('is-loading');
							that._initModals(res);
						}
					})
				})
			})
		}
	}

	_resetCardModalBtn() {
		this.resetForm = document.querySelector('[data-modal-reset-card]');
		let that = this;

		if (!this.resetForm) return false;

		this.resetForm.addEventListener('submit', event => {
			event.preventDefault();

			let formData = $(that.resetForm).serialize();

			$.ajax({
				url: that.resetForm.action,
				type: that.resetForm.method,
				data: formData,
				dataType: 'json',
				beforeSend: function () {
					document.body.classList.add('is-loading');
				},
				success: function (res) {
					document.body.classList.remove('is-loading');

					if (res.containerView) {
						let content = $(res.containerView).find('[data-bonuses-ajax-container]').html();
						$(that.ajaxContainer).html(content);

						that._bindCardFormHandler();
					}

					if (res.modalUrl) {
						$.ajax({
							url: res.modalUrl,
							beforeSend: function () {
								document.body.classList.add('is-loading');
							},
							success: function (res) {
								document.body.classList.remove('is-loading');
								that._initModals(res);
							}
						});

					}
				}
			});
		});
	}

	_moveOnMobile() {
		console.log("move on mobile inited")
		if (window.innerWidth <= 991) {
			$('.sale-personal-section-row-flex').prepend('<div class="col-lg-3 col-sm-4 col-xs-6"><div class="sale-personal-section-index-block bonuses-mobile bx-theme-"></div></div>');

			$('.bonuses').appendTo('.bonuses-mobile');
			this._matchHTML();
			this._bindCardFormHandler();
			this._userProfileBtnHandler();
			this._cardViewHandler();
			this._addCardByNum();
			this._userProfileForm();
			this._bonusCardChoose();
		}
	}
}
